var translations={
  fr: {
    "Home": "Page d'accueil",
    "Teachers": "Enseignants",
    "Classes": "Classes",
    "Tutorials": "Tutoriels",
    "Exercises": "Exercices",
    "Workshops": "Ateliers",
  },
};


import Cookie from 'js-cookie';

import Vue from 'vue';

function getLang() {
  return Cookie.get("language") || "en";
}

function setLang(lang) {
  if (this.$currentLanguage)
    this.$currentLanguage.language=lang;
  if (lang=="en")
    return Cookie.remove("language", {path: "/", sameSite: 'Lax'});
  else
    return Cookie.set("language", lang, {path: "/", sameSite: 'Lax', expires: 365});
}


function format() {
  var str = this, len = arguments.length+1;
  var arg;
  for (var i=0; i<len; arg=arguments[i++]) {
    var safe = typeof arg === 'object' ? JSON.stringify(arg) : arg;
    str = str.replace(RegExp('\\{'+(i-1)+'\\}', 'g'), safe);
  }
  return str;
}

export default {
  install(Vue, options) {
    Vue.getLang=getLang;
    Vue.setLang=setLang;
    Vue.__t=function() {
      var args = Array.prototype.slice.call(arguments, 1);      
      var string=arguments[0] || "";
      if (this.currentLanguage=="fr")
        string=translations.fr[string] || string;
      return format.apply(string, args);
    }
    Vue.prototype.$currentLanguage=new Vue({data: {language: getLang()}});
    Vue.mixin({
      computed: {
        currentLanguage() {
          return this.$currentLanguage.language;
        }
      },
      methods: {
        __t: Vue.__t,
        $getLang: getLang,
        $setLang: setLang
      },
    });
  }
}
